export const taxSlabs = [
  {
    id: "18",
    value: "18",
    name: "18%",
    label: "18%",
  },
  {
    id: "12",
    value: "12",
    name: "12%",
    label: "12%",
  },
  {
    id: "6",
    value: "6",
    name: "6%",
    label: "6%",
  },
  {
    id: "0",
    value: "0",
    name: "0%",
    label: "0%",
  },
];
